<template>
  <div v-if="showFields" class="parent">
    <div class="textInput">
      <label class="label" for="tbox1">{{ Title }}</label>
      <input
        class="input"
        type="text"
        id="tbox1"
        name="tbox1"
        @input="$emit('onChange', $event.target.value)"
        :value="Value"
      /><br />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    Title: {
      type: String,
      default: ""
    },
    showFields: {
      type: Boolean,
      default: false
    },
    Value: {
      type: String,
      default: ""
    },
    error: {
      type: Boolean,
      default: false
    }
  },
  emits: ["onChange"]
};
</script>

<style scoped>
.input {
  width: 260px;
  height: calc(1.4285714286em + 8px);
  border-color: rgba(0, 0, 0, 0.08);
  color: #424242;
  background-color: #ffffff;
  border-radius: 2px;
}
.label {
  font-size: 16px;
}
</style>
